module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/babel-runtime/core-js/object/keys.js
// module id = 27
// module chunks = 0 1